// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__mU2uJ","label":"Labeled_label__1asPm","divider":"Labeled_divider__2vn8f"};